var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-1"},[_c('div',{staticClass:"border-4 border-dashed border-gray-200 rounded-lg h-96"})])}]

export { render, staticRenderFns }